import { render, staticRenderFns } from "./VoyageTable.vue?vue&type=template&id=2ed04107&scoped=true"
import script from "./VoyageTable.vue?vue&type=script&lang=js"
export * from "./VoyageTable.vue?vue&type=script&lang=js"
import style0 from "./VoyageTable.vue?vue&type=style&index=0&id=2ed04107&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed04107",
  null
  
)

export default component.exports